import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              精选研究
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              深度研究文章，提供多维度分析视角
            </p>
          </div>
          <Link
            to="/category/dingyi-jiedu"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {featured.map((article, index) => (
            <ArticleCard key={article.slug} article={article} variant={index === 0 ? 'featured' : 'default'} />
          ))}
        </div>
      </div>
    </section>
  );
}